import React, { useState } from 'react';
import { api } from '../api';

const EMPTY = {
  address: '', city: 'Jacksonville', state: 'FL', zip: '',
  sq_footage: '', bedrooms: '', bathrooms: '',
  status: 'Pre-Deal', partner_name: '',
  purchase_date: '', expected_close_date: '', hold_months: 6,
  purchase_price: '', arv: '',
  profit_pct: 20, backend_pct: 8, frontend_pct: 4, holding_pct_per_month: 1,
  rehab_budget_manual: '', contingency_pct: 10,
  hm_lender: '', hm_loan_amount: '', hm_rate: '', hm_points: '',
};

export default function NewDealModal({ onClose, onCreated }) {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const field = (k, type = 'text') => ({
    type, value: form[k] ?? '',
    onChange: e => set(k, type === 'number' ? e.target.value : e.target.value),
  });

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.address.trim()) { setError('Address is required.'); return; }
    if (!form.bedrooms || !form.bathrooms) {
      setError('Bedrooms and bathrooms are required. The scope of work is built room-by-room from bed/bath count — enter these accurately before continuing.');
      return;
    }
    setSaving(true);
    try {
      const { id } = await api.createDeal(form);
      onCreated(id);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h2>New Deal</h2>
        <form onSubmit={handleSubmit}>

          <div className="form-grid" style={{marginBottom:16}}>
            <div className="span-2">
              <label>Address *</label>
              <input {...field('address')} placeholder="123 Main St" autoFocus />
            </div>
            <div>
              <label>ARV ($)</label>
              <input {...field('arv','number')} placeholder="250000" />
            </div>
            <div>
              <label>Purchase Price ($)</label>
              <input {...field('purchase_price','number')} placeholder="130000" />
            </div>
            <div>
              <label>City</label>
              <input {...field('city')} />
            </div>
            <div>
              <label>Zip</label>
              <input {...field('zip')} />
            </div>
            <div>
              <label>Sq Footage</label>
              <input {...field('sq_footage','number')} placeholder="1200" />
            </div>
            <div>
              <label style={{color: error && (!form.bedrooms || !form.bathrooms) ? 'var(--danger)' : undefined}}>
                Bed / Bath *
              </label>
              <div style={{display:'flex',gap:6}}>
                <input {...field('bedrooms','number')} placeholder="3"
                  style={{border: error && !form.bedrooms ? '1.5px solid var(--danger)' : undefined}} />
                <input {...field('bathrooms','number')} placeholder="2"
                  style={{border: error && !form.bathrooms ? '1.5px solid var(--danger)' : undefined}} />
              </div>
            </div>
            <div>
              <label>Status</label>
              <select value={form.status} onChange={e => set('status', e.target.value)}>
                {['Pre-Deal','Purchased','On Market','Under Contract','Sold'].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label>Rehab Budget ($)</label>
              <input {...field('rehab_budget_manual','number')} placeholder="45000" />
            </div>
            <div>
              <label>Hold Period (months)</label>
              <input {...field('hold_months','number')} />
            </div>
            <div>
              <label>Partner name (optional)</label>
              <input {...field('partner_name')} placeholder="3 Shacks LLC" />
            </div>
          </div>

          {error && <div className="error-msg">{error}</div>}

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Creating…' : 'Create Deal'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
